import React, { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import './Portfolio.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { getProjectById, publicSrc } from '../data/portfolioProjects';

const ProjectDetailPage = () => {
  const { projectId } = useParams();
  const project = getProjectById(projectId);
  const [modalImg, setModalImg] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out',
    });
  }, [projectId]);

  if (!project) {
    return <Navigate to="/portfolio" replace />;
  }

  const heroUrl = publicSrc(project.heroImage);

  const openModal = (img) => setModalImg(img);
  const closeModal = () => setModalImg(null);

  return (
    <div className="portfolio-page">
      <div
        className="portfolio-hero project-detail-hero"
        data-aos="fade-up"
        style={{ backgroundImage: `url(${heroUrl})` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>{project.title}</h1>
          <p>Featured project: metal fabrication and installation</p>
        </div>
      </div>
      <div className="portfolio-main orillia-main-section">
        <div className="orillia-description" data-aos="fade-up" data-aos-delay="40">
          <h2>Project overview</h2>
          {project.overview
            .split(/\n\n+/)
            .filter((block) => block.trim())
            .map((paragraph, i) => (
              <p key={i}>{paragraph.trim()}</p>
            ))}
        </div>
        <div className="orillia-gallery" data-aos="fade-up" data-aos-delay="70">
          <h3>Project gallery</h3>
          <div className="orillia-gallery-grid">
            {project.gallery.map((img, idx) => (
              <img
                key={img}
                src={publicSrc(img)}
                alt={`${project.title}, gallery ${idx + 1}`}
                className="orillia-gallery-img"
                data-aos="fade-up"
                data-aos-delay={40 + idx * 18}
                onClick={() => openModal(publicSrc(img))}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="portfolio-cta" data-aos="fade-up" data-aos-delay="160">
        <h2>Ready to start your project?</h2>
        <p>Let&apos;s discuss how we can bring your vision to life</p>
        <Link to="/contact" className="cta-button">
          Get in touch
        </Link>
      </div>
      {modalImg && (
        <div className="lightbox-modal" onClick={closeModal}>
          <div className="lightbox-modal-content" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="lightbox-close" onClick={closeModal}>
              &times;
            </button>
            <img src={modalImg} alt="" className="lightbox-img" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetailPage;
